'use client';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { EpStepContent } from '../components';
import { EpFormInput } from '../components/EpFormInput';

export default function PatientNameInput({
  translations,
  isPharmacy = false,
}: {
  translations: string[];
  isPharmacy?: boolean;
}) {
  const {
    resetField,
    setValue,
    formState: { errors },
  } = useFormContext();

  const PersonValue = useWatch({ name: 'person.inputValue' });
  const NoId = useWatch({ name: 'noId' });
  const personType = useWatch({ name: 'personType' });
  const checkIfIsPersonValid =
    (PersonValue === 'true' || PersonValue === undefined) && !!NoId;
  const checkIfIsPersonType =
    personType?.inputValue && personType?.inputValue !== '1';
  const isVisible = checkIfIsPersonValid || checkIfIsPersonType || isPharmacy;

  function handleChange() {
    setValue('formUtils.stepNeedReview', '2');
    resetField('unitId.inputValue');
    resetField('unitId.inputLabel');
  }

  if (!isVisible) return null;

  return (
    <>
      <EpStepContent.Label label={t(translations, 'Full Name') + ' *'}>
        <EpFormInput
          inputOnChangeFunc={handleChange}
          inputRequired
          inputName="patientName"
          inputType="text"
          inputPlaceholder={t(translations, `Person's full name`)}
          translations={translations}
          inputIsFullWidth
          inputWithError={!!errors[`patientName`]}
          errorMessage={t(translations, '* Required Fied')}
          inputMaxLength={100}
        />
      </EpStepContent.Label>
      {/* <EpErrorMessage inputName="patientName" /> */}
    </>
  );
}
